import { render, staticRenderFns } from "./CreateTabletDialog.vue?vue&type=template&id=5581d51a&scoped=true"
import script from "./CreateTabletDialog.vue?vue&type=script&lang=ts"
export * from "./CreateTabletDialog.vue?vue&type=script&lang=ts"
import style0 from "./CreateTabletDialog.vue?vue&type=style&index=0&id=5581d51a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5581d51a",
  null
  
)

export default component.exports